// extracted by mini-css-extract-plugin
export default {"container":"can_container__eErNy","inner":"can_inner__NuCOU","text":"can_text__HKbGq","icon":"can_icon__oVZ9o"};